import React from 'react';
import { CardContent, CardMedia } from '@mui/material';
import { Link } from 'react-router-dom';
import { StyledCard, CardTitle, Description } from './styles';

export const MyDataCard = ({ item }) => {
  return (
    <StyledCard
      sx={{
        maxWidth : { xs: '100%' },
        minWidth : '240px',
        flex     : 1,
      }}
      data-testid='mydatacard'>
      <a
        style={{
          display        : 'flex',
          flex           : '1',
          justifyContent : 'center',
          flexDirection  : 'column',
        }}
        href={item.pdfLink}
        target='_blank'
        data-testid='mydatacard-link'
        rel='noreferrer'>
        <CardMedia
          component='img'
          height='140'
          image={item.image}
          alt={item.title}
          style={{ objectFit: item.fit ?? 'cover' }}
          data-testid='mydatacard-image'
        />
        <CardContent>
          <CardTitle
            variant='h6' data-testid='mydatacard-title'>{item.title}</CardTitle>
          <Description
            variant='pl3' data-testid='mydatacard-description'>{item.description}</Description>
        </CardContent>
      </a>
    </StyledCard>
  );
};
